module.exports = __webpack_public_path__ + "img/O2O-pic1-03.66515b09.png";